import { useState, useEffect } from "react"


// Default logo dimensions
export const defaultLogoDimensions = {
    width: 200,
    height: 200
}

const useLogoStorage = () => {

    const storageKey = "logoSettings" // localStorage key
    
    

    // State to hold current logo dimensions
    const [logoDimensions, setLogoDimensions] = useState(defaultLogoDimensions)

    // Load from localStorage on mount
    useEffect(() => {
        try {
            const stored = localStorage.getItem(storageKey)
            if (stored) {
                const parsed = JSON.parse(stored)
                setLogoDimensions(parsed)
            }
        } catch (error) {
            console.warn('Failed to load logo settings from localStorage:', error)
            setLogoDimensions(defaultLogoDimensions)
        }
    }, [])

    // Function to save to localStorage
    const saveLogoDimensions = (dimensions) => {
        try {
            localStorage.setItem(storageKey, JSON.stringify(dimensions))
            setLogoDimensions(dimensions)
        } catch (error) {
            console.error('Failed to save logo settings to localStorage:', error)
        }
    }

    // Function to remove from localStorage
    const clearLogoDimensions = () => {
        try {
            localStorage.removeItem(storageKey)
            setLogoDimensions(defaultLogoDimensions)
        } catch (error) {
            console.error('Failed to clear logo settings from localStorage:', error)
        }
    }

    return [logoDimensions, saveLogoDimensions, clearLogoDimensions]
}

export default useLogoStorage
